module.exports = __webpack_public_path__ + "static/img/ewm.750b761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm.jpg
// module id = Wnh9
// module chunks = 0